<span class="sr-only">{{ content }}</span>
<div class="content body-regular" id="message-content" aria-hidden="true">{{ content }}</div>
<div  class="icon" aria-hidden="true">
    <vpg-icon-next [icon]="icon" size="3x" class="message-icon"></vpg-icon-next>
    <vpg-badge class="icon-badge" *ngIf="numberOfMessages"></vpg-badge>
</div>
